import type React from "react";
import { twMerge } from "tailwind-merge";

interface DialogContentProps {
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

export function DialogContent({ children, className, style }: DialogContentProps) {
    return (
        <div
            className={twMerge(
                "text-dark pr-4 -mr-4 overflow-y-auto max-h-[calc(80vh-120px)] min-h-[160px] py-2",
                className,
            )}
            style={style}
        >
            {children}
        </div>
    );
}
